<template>
  <v-layout column class="cirrus-comparison-body oct-browser-body fill-height">
    <v-flex shrink>
      <oct-comparison-toolbar />
    </v-flex>
    <v-flex fill-height>
      <v-row no-gutters class="fill-height oct-comparison-wrapper">
        <v-col cols="6" class="fill-height oct-comparison-view" :style="borderStyle">
          <component :is="compare && compare.componentName || 'cirrusComparisonView'" 
            name="compare"
            :context="compare"
            :exams="compareExams"
            :groups="compareGroups"/>
        </v-col>
        <v-col cols="6" class="fill-height oct-comparison-view" :style="borderStyle">
          <component :is="baseline && baseline.componentName || 'cirrusComparisonView'" 
            name="baseline"
            :context="baseline"
            :exams="baselineExams"
            :groups="baselineGroups"/>
        </v-col>
      </v-row>
    </v-flex>
  </v-layout>
</template>

<script>
import octComparisonToolbar from "./OCTComparisonToolbar";
import cirrusComparisonView from "./CirrusComparisonView";
import rasterComparisonView from "./RasterComparisonView";
import { mapGetters } from "vuex";
export default {
  name: "cirrusComparisonBody",
  components: { octComparisonToolbar, cirrusComparisonView, rasterComparisonView },
  computed: {
    ...mapGetters([
      "baseline",
      "baselineExams",
      "baselineGroups",
      "compare",
      "compareExams",
      "compareGroups"
    ])
  }
};
</script>
